import { memo, useEffect, useState, useRef } from "react"
import { ScrollArea } from "@chakra-ui/react"
import ProductService from "@/services/product"
import { Stack, Alert, CloseButton, Image, EmptyState, Center, Button, Box, Text, AspectRatio, Input, Card, VStack, HStack, Separator, Heading, Flex } from "@chakra-ui/react"

import { formatCurrency } from "@/utilities/number"
import { LuPencil, LuLaptop } from "react-icons/lu"

import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import CtvService from "services/ctv"
import { useNavigate, useParams, useSearchParams } from "react-router"
import { Grid, GridItem } from "@chakra-ui/react"
import WithLoginPage from "@/components/withlogin"
import moment from "moment";
import { useAuth } from "contexts/auth";
import { useStore } from "contexts/store";
import Withdraw from "./Withdraw"
import Share from "./Share"
import { FaShare, FaStreetView } from "react-icons/fa"
import ProductShare from "pages/product/Share"

import _ from "lodash"
const service = new CtvService();


const ProductItem = memo(({ data, showShare }) => {
    const navigate = useNavigate();
    return (



        <div style={{ display: "flex", gap: 16, }}>
            <div style={{ flex: 0.3 }} onClick={e => navigate(`/product/${data.id}`)}>

                <div style={{ justifyContent: "center", height: "100%", display: "flex", flexDirection: "column" }}>



                    <AspectRatio maxW="400px" ratio={4 / 3}>
                        <Image src={data.thumbnail?.md_url}
                            alt={data.name} objectFit="cover" />
                    </AspectRatio>
                </div>
            </div>

            <div style={{ flex: 0.7 }}>


                <div style={{ display: "flex" }}>
                    <div style={{ flexGrow: 1, flexShrink: 1 }}>
                        <Text lineClamp={1} textStyle="md" fontWeight="medium" >{data.name}</Text>
                    </div>
                    <div>

                    </div>

                </div>



                <Text lineClamp={2} >
                    <HStack>
                        <div>
                              <Text color={"red.500"} fontWeight="semibold">Kiếm được:</Text>
                     
                        </div>

                        <div >
                            <Text color={"red.500"} fontWeight="semibold">


                                {data.min_commission == data.max_commission ?
                                    <>
                                        {formatCurrency(data.min_commission)}
                                    </> :
                                    <>
                                        {formatCurrency(data.min_commission)} -    {formatCurrency(data.max_commission)}
                                    </>
                                }
                            </Text>
                        </div>
                        

                    </HStack>


                </Text>

                
                <Text lineClamp={2} >
                    <HStack>
                        <div>
                            Giá
                        </div>
                        <div>


                            {data.min_price == data.max_price ?
                                <>
                                    {formatCurrency(data.min_price)}đ
                                </> :
                                <>
                                    {formatCurrency(data.min_price)}đ -    {formatCurrency(data.max_price)}đ
                                </>
                            }
                        </div>
                    </HStack>
                </Text>
                <div>
                    <Flex justify={"flex-end"}>
                        <HStack>
                            <Button variant={"ghost"} size={"sm"} onClick={e => navigate(`/product/${data.id}`)}><LuLaptop ></LuLaptop></Button>
                            <Button variant={"ghost"} size={"sm"} onClick={showShare}><FaShare></FaShare></Button>
                        </HStack>

                    </Flex>



                </div>

            </div>



        </div>


        // <Grid templateColumns="repeat(4, 1fr)" gap="6">

        //     <GridItem colSpan={1}>


        //         <AspectRatio maxW="400px" ratio={4 / 3}>
        //             <Image src={data.thumbnail?.md_url}
        //                 alt={data.name} objectFit="cover" />
        //         </AspectRatio>

        //     </GridItem>
        //     <GridItem colSpan={3}>
        //         {data.name}
        //     </GridItem>
        // </Grid>

    )
})









export default ProductItem;